import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=0702da4a&scoped=true&"
import script from "./Section.vue?vue&type=script&lang=js&"
export * from "./Section.vue?vue&type=script&lang=js&"
import style0 from "./Section.vue?vue&type=style&index=0&id=0702da4a&prod&lang=scss&scoped=true&"
import style1 from "./Section.vue?vue&type=style&index=1&id=0702da4a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0702da4a",
  null
  
)

export default component.exports